import { axiosGet } from '../ServiceBase.js';

/**
 * Envía mensaje de cancelación vía WebSocket al afiliado
 * @param {string} token - Token del QR/orden
 * @returns {Promise}
 */
export const sendMessageOrdenCancelada = async (token) => {
  return axiosGet(`/v1/websocket-ordenes/send-cancelada?token=${token}`);
};
